import { getString } from "../../common/common";

export const EMAIL_ID = 'Email_ID';
export const EMAIL_ID_ERR = 'Enter_valid_email_id';


export const translations = {
    en: {
        [EMAIL_ID]: 'Email ID',
        [EMAIL_ID_ERR]: 'Enter valid email id',
    },
    kn: {
        [EMAIL_ID]: 'ಇಮೇಲ್ ಐಡಿ',
        [EMAIL_ID_ERR]: 'ಸರಿಯಾದ ಇಮೇಲ್ ಐಡಿ ಎಂಟರ್ ಮಾಡಿ',
    },
};

export const t = (key = "") => {
    return getString(key, translations)
}